import React from 'react';
const CoopSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-coop" });
CoopSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-coop sirius-icon-coop-enhance" });
export default CoopSvg;
